/* eslint-disable react-hooks/exhaustive-deps */
import { useLiveQuery } from "dexie-react-hooks";
import { set } from "idb-keyval";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import { useGetProdutoFilialMicro } from "~hooks/useBackOffice";
import useWorker from "~hooks/useWorker";

const useProdutoFilialPrecoRegraMicrorregiao = ({ microrregiaoId, clusterId, data }) => {  //TODO Rever onde usa e trocar @Vini
  const [filialId, setFilialId] = useState();
  const [grupoMaterialId, setGrupoMaterialId] = useState();

  const [precosRegraDisponiveis, setPrecosRegraDisponiveis] = useState([]);

  useEffect(() => {
    const fetchPrecosRegraDisponiveis = async () => {
      let query = db.tabelaPreco;

      if (microrregiaoId) {
        query = query.filter(x => x.microrregiaoId === microrregiaoId);
      }

      if (clusterId) {
        query = query.filter(x => x.clusterId === clusterId);
      }

      const precos = [];
      await query.each(item => precos.push(item));
      setPrecosRegraDisponiveis(precos);
    };

    fetchPrecosRegraDisponiveis();
  }, [microrregiaoId, clusterId]);

  const filiaisDisponiveis = useMemo(() => {
    return (precosRegraDisponiveis || []).map(precoRegra => precoRegra.filialId).filter((val, i, arr) => arr.indexOf(val) === i);
  }, [precosRegraDisponiveis]);

  const gruposMateriaisDisponiveis = useMemo(() => {
    return (precosRegraDisponiveis || []).filter(pr => (!filialId || pr.filialId === filialId)).map(precoRegra => precoRegra.grupoMaterialId).filter((val, i, arr) => arr.indexOf(val) === i);
  }, [precosRegraDisponiveis, filialId]);

  const familiasDisponiveis = useMemo(() => {
    return (precosRegraDisponiveis || []).filter(pr => (!filialId || pr.filialId === filialId) && (!grupoMaterialId || pr.grupoMaterialId === grupoMaterialId) && pr.familiaId).map(precoRegra => precoRegra.familiaId).filter((val, i, arr) => arr.indexOf(val) === i);
  }, [precosRegraDisponiveis, filialId, grupoMaterialId]);

  const produtosDisponiveis = useMemo(() => {
    return (precosRegraDisponiveis || []).filter(pr => (!filialId || pr.filialId === filialId) && (!grupoMaterialId || pr.grupoMaterialId === grupoMaterialId)).map(precoRegra => precoRegra.produtoId).filter((val, i, arr) => arr.indexOf(val) === i);
  }, [precosRegraDisponiveis, filialId, grupoMaterialId]);

  const opcoesDisponiveis = useMemo(() => {
    let filiaisObj = {};
    let grupoProdutosIdsObj = {};
    let produtosIdsObj = {};

    for (const e of precosRegraDisponiveis) {
      if (e.filialId !== undefined) filiaisObj[e.filialId] = e.filialId;

      if (!data?.filial || e.filialId === data.filial) {

        if (e.grupoMaterialId !== undefined) grupoProdutosIdsObj[e.grupoMaterialId] = e.grupoMaterialId;

        if (!data?.grupoProduto || e.grupoMaterialId === data.grupoProduto) {
          if (e.produtoId !== undefined) produtosIdsObj[e.produtoId] = e.produtoId;
        }
      }
    }

    return {
      filiaisIds: Object.values(filiaisObj),
      grupoProdutosIds: Object.values(grupoProdutosIdsObj),
      produtosIds: Object.values(produtosIdsObj)
    };
  }, [data, precosRegraDisponiveis]);

  return {
    precosRegraDisponiveis,
    filiaisDisponiveis,
    gruposMateriaisDisponiveis,
    familiasDisponiveis,
    produtosDisponiveis,
    setFilialId,
    setGrupoMaterialId,
    opcoesDisponiveis
  };
}

export default useProdutoFilialPrecoRegraMicrorregiao;